'use client';
import type { ReactNode } from 'react';
import { ColorType, getColorValue } from '@/theme/colors';
import type { ColoredSegment } from './Cbullshitcoding.typing';
const DEFAULT_VALUE = "default";
interface CbullshitcodingSegmentsProps {
    segments: ColoredSegment[];
    opacity: number;
    lineIdentity: string;
}
/** Resolve a colour token (a `#hex` or a ColorType value) to a CSS colour. */
function resolveSegmentColor(input: {
    color: string;
    opacity: number;
}): string | undefined {
    if (input.color.startsWith('#')) {
        return getColorValue(input.color, input.opacity);
    }
    return (Object.values(ColorType) as string[]).includes(input.color)
        ? getColorValue(input.color as ColorType, input.opacity)
        : undefined;
}
export function CbullshitcodingSegments({ segments, opacity, lineIdentity, }: CbullshitcodingSegmentsProps): ReactNode {
    return (<>
      {segments.map((segment, index) => {
            const resolved = segment.color
                ? resolveSegmentColor({ color: segment.color, opacity })
                : undefined;
            const segmentIdentity = `${segment.color ?? DEFAULT_VALUE}-${segment.text}`;
            return (<span key={`${segmentIdentity}-${index}`} style={resolved ? { color: resolved } : undefined}>
        {segment.text}
      </span>);
        })}
    </>);
}
